import { useTranslation } from "~/i18n"
import Text from "~/components/UI/Text"
import Link from "~/components/UI/Link"
import { EMAIL, HOTLINE } from "~/constant"
import styled from "styled-components"
import { COLORS } from "../UI/Constants"

const StyledLink = styled(Link)`
  :hover {
    p {
      color: ${COLORS.PRIMARY};
      opacity: 1;
    }
  }
`

const Contact = () => {
  const [t] = useTranslation()
  return (
    <>
      <Text bold style={{ lineHeight: '40px' }}>
        {t('Thông tin liên hệ')}
      </Text>

      <StyledLink target='_blank' href={`mailto:${EMAIL}`}>
        <Text margin='8px 0' opacity={0.7}>
          {t('Email: ')}{EMAIL}
        </Text>
      </StyledLink>
      <StyledLink target='_blank' href={`Tel:${HOTLINE}`}>
        <Text margin='8px 0' opacity={0.7}>
          {t('Hotline: ')}{HOTLINE}
        </Text>
      </StyledLink>
    </>
  )
}

export default Contact
